import { AttachmentType } from 'Shared/constants/types';

export enum ContentType {
  IMAGE = 'image',
  PDF = 'pdf',
  SVG = 'svg',
  OTHER = 'other',
}

export type PropsType = {
  attachment: AttachmentType;
  isOpen: boolean;
  onToggle(): void;
};
